import { useSeo } from "@/seo";
import { Reveal, Eyebrow } from "@/components/Reveal";

export function Privacy() {
  useSeo({ title: "Privacy Policy, TruVerse Middle East", description: "How TruVerse Middle East collects, uses and protects your personal data." });
  return (
    <div className="container-site max-w-3xl py-24" data-testid="privacy-page">
      <Reveal>
        <Eyebrow>Legal</Eyebrow>
        <h1 className="mt-4 text-4xl tracking-tight text-foreground md:text-5xl">Privacy Policy</h1>
        <div className="mt-10 space-y-6 text-sm leading-relaxed text-muted-foreground md:text-base">
          <p>TruVerse Middle East collects only the personal data you give us through our contact form, downloads and booking tools: your name, company, email, phone number and message.</p>
          <p>We use this data to respond to your enquiry, deliver requested resources and arrange consultations. We do not sell your data, and we do not share it with third parties except the service providers that operate this website and our booking tools.</p>
          <p>Data is stored securely and retained only as long as needed for the purpose it was collected. You may ask us to correct or delete your data at any time by writing to pro@truverse.in.</p>
          <p>Cookies: this site sets necessary cookies by default. Analytics cookies load only with your consent, which you can change by clearing your browser's site data.</p>
        </div>
      </Reveal>
    </div>
  );
}

export function Terms() {
  useSeo({ title: "Terms of Use, TruVerse Middle East", description: "Terms governing the use of the TruVerse Middle East website." });
  return (
    <div className="container-site max-w-3xl py-24" data-testid="terms-page">
      <Reveal>
        <Eyebrow>Legal</Eyebrow>
        <h1 className="mt-4 text-4xl tracking-tight text-foreground md:text-5xl">Terms of Use</h1>
        <div className="mt-10 space-y-6 text-sm leading-relaxed text-muted-foreground md:text-base">
          <p>The content on this website is general information. It is not tax, legal or investment advice, and it does not create an advisor client relationship.</p>
          <p>Figures, thresholds and regulatory references are provided for guidance and may change. Confirm positions against current rules before acting.</p>
          <p>Engagements with TruVerse Middle East are governed by separate engagement letters. TruVerse provides advisory and setup services; regulated activities are carried out with licensed partners where required.</p>
          <p>All content on this site is the property of TruVerse and may not be reproduced without permission.</p>
        </div>
      </Reveal>
    </div>
  );
}
